import { Link } from 'react-router-dom';
import NowSection from '../components/NowSection';

const RightPanel = ({ homepage }) => {
  return (
    <div className="w-full md:w-1/2 flex items-start justify-center flex-col px-6 py-10 md:px-20 md:py-24">
      <h1 className="text-4xl md:text-6xl font-bold mb-2 intro-item intro-hello">
        {homepage.headlineGreeting}
      </h1>
      <h2 className="text-base md:text-lg font-semibold mb-6 intro-item intro-subtitle">
        {homepage.subHeadline}
      </h2>
      <div className="flex flex-col md:flex-row gap-4 mb-6 w-full">
        <Link
          to="/resume"
          className="bg-teal-800 text-white px-5 py-2 rounded-full w-full md:w-auto text-center hover:text-black"
        >
          RESUME
        </Link>
        <Link
          to="/projects"
          className="border border-black px-5 py-2 rounded-full w-full md:w-auto text-center hover:text-teal-600"
        >
          PROJECTS
        </Link>
      </div>
      <p className="text-sm text-gray-700 mb-3">{homepage.bio1}</p>
      <p className="text-sm text-gray-700">{homepage.bio2}</p>
      <NowSection />
    </div>
  );
};

export default RightPanel;
